import { createContext, useContext, useMemo, useState } from 'react';
import { demoLesson } from '../../constants/guideDemo.fr';

export const GUIDE_DEMO = Object.freeze({ LESSON: 'lesson' });

const localIsoDate = (now = new Date()) => {
  const pad = (value) => String(value).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

const NO_DEMO = Object.freeze({ lesson: null, setDemo: () => {} });
const GuideDemoContext = createContext(NO_DEMO);

/** Which example data the running guide shows (FirstUseGuide sets it per step; Home reads `lesson`). In memory only. */
export function GuideDemoProvider({ children }) {
  const [demo, setDemo] = useState(null);
  const value = useMemo(() => ({
    lesson: demo === GUIDE_DEMO.LESSON ? demoLesson(localIsoDate()) : null,
    setDemo,
  }), [demo]);
  return <GuideDemoContext.Provider value={value}>{children}</GuideDemoContext.Provider>;
}

export const useGuideDemo = () => useContext(GuideDemoContext);
